import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  ViewRef
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
isLoading:boolean = true;
currentMenu : any
  private _mobileQueryListener: () => void;

  constructor(
   private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private router: Router
  ) {
    
   
    this.currentMenu =this.menuItems.getMenuitem('all');
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      console.log('Navigation changed:', event.urlAfterRedirects);

      // you can read activeIndex from localStorage here
      const activeIndex = localStorage.getItem('activeIndex');
      this.activeRoute(activeIndex)
      console.log('Active index:', activeIndex);

      this.detectChanges();
    });
  }

  active(index) {
    console.log("active")
    setTimeout(() => {
      console.log(index)
      localStorage.setItem('activeIndex',index);
      this.detectChanges()
      this.ngOnDestroy();
    },280)

 
  }
  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }

  activeRoute(index) {
    localStorage.setItem("activeIndex", index);
  }
  detectChanges () {
    console.log("CHanges")
    // Programmatically run change detection to fix issue in Safari
    setTimeout(() => {
      // this.isLoading = true;
        if ( this.changeDetectorRef !== null &&
            this.changeDetectorRef !== undefined &&
            ! (this.changeDetectorRef as ViewRef).destroyed ) {
                this.changeDetectorRef.detectChanges();
                // this.isLoading = false;
        }

    },580);
}

  ngOnDestroy(): void {
    console.log("DESTROY")
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  checkType(val: any): string {
    return typeof val;
  }
  
}
